import { clientApi } from "../api/config";

export async function __insertCard(__updateCard: (e: any) => void) {
  if (typeof window.PaypleCpayPopup !== "function") {
    throw new Error("페이플 결제 모듈을 불러오지 못했습니다. 페이지를 새로고침한 후 다시 시도해주세요.");
  }
  const { data: { sts_fg, succ_obj, err_msg } } = await clientApi.get("/cstm/crd/auth");
  if (!sts_fg) {
    throw new Error(err_msg || "페이플 카드 등록 인증에 실패했습니다.");
  }
  if (!succ_obj?.AuthKey || !succ_obj?.return_url) {
    throw new Error("페이플 카드 등록 인증 정보가 없습니다.");
  }
  const { AuthKey, return_url } = succ_obj;
  const info = {
    PCD_AUTH_KEY: AuthKey,
    PCD_CARD_VER: "01",
    PCD_PAY_TYPE: "card",
    PCD_PAY_URL: return_url,
    PCD_PAY_WORK: "AUTH",
    callbackFunction: __updateCard,
  };
  window.PaypleCpayPopup(info);
}
